import { el, setChildren, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import { decorateWithShowHide } from 'decorators/ui';

import deleteIconString from 'assets/images/delete-icon.svg?raw';
import moreActionsIndicatorIconString from 'assets/images/more-actions-indicator-icon.svg?raw';
import editIconString from 'assets/images/edit-icon.svg?raw';
import filterIconString from 'assets/images/filter-icon.svg?raw';
import archiveIconString from 'assets/images/archive-icon.svg?raw';
import eyeOpenIconString from 'assets/images/eye-open-icon.svg?raw';
import eyeClosedIconString from 'assets/images/eye-closed-icon.svg?raw';

import './index.scss';

const deleteIcon = stringToSVG(deleteIconString);
const moreActionsIndicatorIcon = stringToSVG(moreActionsIndicatorIconString);
const editIcon = stringToSVG(editIconString);
const filterIcon = stringToSVG(filterIconString);
const archiveIcon = stringToSVG(archiveIconString);
const eyeOpenIcon = stringToSVG(eyeOpenIconString);
const eyeClosedIcon = stringToSVG(eyeClosedIconString);

class IconButton {

  constructor(configuration) {

    this.clickHandler = configuration.onClick;
    this.icon = configuration.icon;
    this.working = false;

    this.el = el('button', {
      tabindex: configuration.tabindex,
      id: configuration.id || '' + Date.now(),
      type: 'button',
      class: configuration.class || '',
      onclick: this.onClick.bind(this)
    }, this.icon.cloneNode(true));

  }

  setActive() {

    this.el.classList.add('active');

  }

  setInactive() {

    this.el.classList.remove('active');

  }

  setReadOnly(readOnly) {

    setAttr(this.el, {
      disabled: readOnly
    });

  }

  setIcon(icon) {

    this.icon = icon;

    setChildren(this.el, [this.icon.cloneNode(true)]);

  }

  async onClick(event) {

    if (this.working === true) {
      return;
    }

    this.working = true;

    setChildren(this.el, [el('ht-spinner', { size: 'small' })]);

    try {
      await this.clickHandler(event);
    } catch (exception) {
      throw exception;
    } finally {

      setChildren(this.el, [this.icon.cloneNode(true)]);

      this.working = false;

    }
  }

  update() {

  }

  static deleteButton(configuration) {

    const deleteButton = new IconButton({
      class: 'application-button round-button button-with-stroke-svg',
      onClick: configuration.onClick,
      icon: deleteIcon
    });

    return deleteButton;

  }

  static deleteButtonSmall(configuration) {

    const deleteButton = new IconButton({
      ...configuration,
      class: 'application-button round-button button-with-stroke-svg small',
      onClick: configuration.onClick,
      icon: deleteIcon
    });

    return deleteButton;

  }

  static moreActionsButton(configuration) {

    const moreActionsButton = new IconButton({
      class: 'application-button round-button button-with-stroke-svg',
      onClick: configuration.onClick,
      icon: moreActionsIndicatorIcon
    });

    return moreActionsButton;

  }

  static editButton(configuration) {

    const editActionButton = new IconButton({
      class: 'application-button round-button button-with-stroke-svg',
      onClick: configuration.onClick,
      icon: editIcon
    });

    return editActionButton;

  }

  static filterButton(configuration) {

    const filterActionButton = new IconButton({
      class: 'application-button round-button',
      onClick: configuration.onClick,
      icon: filterIcon
    });

    return filterActionButton;

  }

  static visibilityButtonSmall(configuration) {

    const visibilityButton = new IconButton({
      ...configuration,
      class: 'application-button round-button button-with-stroke-svg small',
      onClick: configuration.onClick,
      icon: eyeClosedIcon
    });

    return visibilityButton;

  }

  static archiveButton(configuration) {

    const archiveActionButton = new IconButton({
      class: 'application-button round-button button-with-stroke-svg',
      onClick: configuration.onClick,
      icon: archiveIcon
    });

    return archiveActionButton;

  }

}

IconButton.icons = {
  EYE_OPEN: eyeOpenIcon,
  EYE_CLOSED: eyeClosedIcon
};

export default decorateWithShowHide(IconButton);